/**
 * Argo OS — design tokens shared between TS and CSS.
 * Mirror of the :root variables in src/index.css. When adding a new
 * token, update both files (they are intentionally redundant so
 * components can import without an extra runtime read).
 */

export const C = {
  // ink
  ink950: '#0a0a10',
  ink900: '#121218',
  ink800: '#191922',
  ink700: '#22222e',

  // brand accents
  magenta: '#FF00FF',
  magentaDeep: '#BB4198',
  magentaSoft: '#E879D9',
  orange: '#FDAD01',
  orangeWarm: '#E23939',
  blueElectric: '#0082F3',
  blueLight: '#589DFF',
  blueDeep: '#2F01FD',
  green: '#22C55E',
  greenSoft: '#027A48',

  // text
  text: 'rgba(245, 247, 255, 0.96)',
  textMuted: 'rgba(220, 226, 240, 0.7)',
  textDim: 'rgba(180, 188, 210, 0.5)',
} as const;
